/**
 * Tuning Constants
 *
 * Named constants for empirical thresholds that appear in multiple locations.
 * Each constant includes rationale for the chosen value.
 */

/** Stale time for slowly-changing reference data (orgs, networks, attributes). 5 min balances freshness vs API load. */
export const REFERENCE_DATA_STALE_MS = 5 * 60 * 1000;

/** Delay before auto-saving editor field changes to the server */
export const EDITOR_AUTOSAVE_DEBOUNCE_MS = 500;

/** Delay before triggering search after user stops typing. 300ms balances responsiveness vs API load. */
export const SEARCH_DEBOUNCE_MS = 300;
